
import WidgetsIcon from '@/components/finagent/icons/WidgetsIcon';

export default {
    name: 'FinAgentAutoWidgetsToggle',

    components: {
        WidgetsIcon,
    },

    computed: {
        isEnabled() {
            return this.$store.state.preferences.finAgentAutoWidgetsEnabled;
        },
        widgetsIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/finagent-details-icon-dark.svg') :
                require('@/assets/icons/finagent-details-icon-light.svg');
        },
    },

    methods: {
        handleChange(newValue) {
            this.$store.commit('preferences/setFinAgentAutoWidgetsEnabled', newValue);
        },
        handleClickArea() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                return;
            }

            this.$store.commit('preferences/setFinAgentAutoWidgetsEnabled', !this.isEnabled);
        }
    }
}
